import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.financialExchangeRate.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.financialExchangeRate.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.financialExchangeRate.save,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存列表
export function saveAll(requestBody) {
  return request({
    url: URL.finance.financialExchangeRate.saveAll,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(params) {
  return request({
    url: URL.finance.financialExchangeRate.remove,
    method: 'delete',
    params
  })
}

// 初始化新的集团汇率
export function initNewRates() {
  return request({
    url: URL.finance.financialExchangeRate.initNewRates,
    method: 'get'
  })
}

// 加载集团汇率
export function loadByAccountSet(data) {
  return request({
    url: URL.finance.financialExchangeRate.loadByAccountSet,
    method: 'post',
    data
  })
}
